import React, { useEffect, useState, useCallback } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { Select, MenuItem } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import DownArrowIcon from './images/downArrow.svg';
import DefaultSelectionIcon from './images/defaultSelect.svg';
import css from './index.module.scss';
const { useSelector, useDispatch } = Redux;
const { selectAllMain, selectCategoryById } = Slices.categorySlice;
// const { selectValuesOfTags } = Slices.tagsSlice;
// const tagsState = useSelector((state) => state.tags);
const Filter = ({
  selectedCategoryTag,
  handleCategoryTagSelection,
  setCategoryTags,
  categoryTags,
  categoryID,
}) => {
  const intl = useIntl();
  // const categories = useSelector(selectAllMain);
  const tagsState = useSelector((state) => state.tags);
  const cat = useSelector((state) => selectCategoryById(state, categoryID));
  // const [categoryTags, setCategoryTags] = useState([]);
  useEffect(() => {
    if (tagsState.status === 'succeeded') {
      const tagsData = Object.values(tagsState?.data || {}).sort(
        (tag1, tag2) => tag1.position - tag2.position
      );
      setCategoryTags(() => tagsData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagsState.status]);
  return (
    <div className={css.tabContentHeader}>
      <div className={css.tabContentTitle}>
        <h1>
          {cat?.name == 'My Favorites' ? (
            <FormattedMessage id="profile_myfavorites" defaultMessage="My Favorites" />
          ) : (
            cat?.name
          )}
        </h1>
      </div>
      <div className={css.filterContainer}>
        <Select
          value={selectedCategoryTag}
          label=""
          // displayEmpty
          className={css.tagFilters}
          disableUnderline={true}
          IconComponent={() => <img src={DownArrowIcon} />}
        >
          <MenuItem
            className={css.selectBoxItem}
            value={0}
            selected={true}
            onClick={() => handleCategoryTagSelection(0)}
          >
            <span className={css.tagFilterItem}>
              <img src={DefaultSelectionIcon} alt={'Select Tag'} />
              <FormattedMessage id="filter_by" defaultMessage={'Filter By'} />
            </span>
          </MenuItem>
          {categoryTags.map((category) => {
            let categoryName =
              category.tagName[intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)];
            return (
              <MenuItem
                value={category.tagId}
                className={css.selectBoxItem}
                onClick={() => handleCategoryTagSelection(category.tagId)}
              >
                <span className={css.tagFilterItem}>
                  <img src={category.asset.default} alt={categoryName} /> {categoryName}
                </span>
              </MenuItem>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

export default Filter;
